import React from 'react';
import classnames from 'classnames';

import CloseSVG from '../svg/icons/close.svg';
import MenuSVG from '../svg/icons/menu.svg';

const MenuToggle = ({ className = 'text-white', onClick, open }) => {
  const buttonClass = classnames(
    'appearance-none focus:outline-none',
    className
  );
  const svgClass = 'h-5 fill-current w-5';

  return (
    <button className={buttonClass} onClick={onClick}>
      {open ? (
        <CloseSVG className={svgClass} />
      ) : (
        <MenuSVG className={svgClass} />
      )}{' '}
      <span className="sr-only">{open ? `Close menu` : `Menu`}</span>
    </button>
  );
};

export default MenuToggle;
